import * as React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";
import { ControlArrowRight } from "./icons/Arrows";

const BoldLinkStyles = css<IBoldLinkStyleProps>`
  display: inline-flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes[1]};
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;
  ${(props) =>
    props.variant === "light" &&
    css`
      color: ${({ theme }) => theme.colors.white};
    `}

  &:hover {
    text-decoration: underline;
  }
`;

const StyledBoldLink = styled(Link)<IBoldLinkStyleProps>`
  ${BoldLinkStyles}
`;

interface IBoldLinkStyleProps {
  variant?: string;
}
interface IBoldLinkProps {
  children: React.ReactNode;
  to: string;
}

type IProps = IBoldLinkStyleProps & IBoldLinkProps;

const BoldLink: React.FC<IProps> = ({ children, to, variant }) => (
  <StyledBoldLink variant={variant} to={to}>
    {children}
    <ControlArrowRight />
  </StyledBoldLink>
);

export default BoldLink;
